import React, { useState, useEffect } from 'react';
import { Table, Card, Tag, Button, Space, Alert } from 'antd';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { WarningOutlined } from '@ant-design/icons';

const FraudDetection = () => {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAlerts = async () => {
      try {
        // Example: fetch suspicious consultations
        const q = query(
          collection(db, 'consultations'),
          where('status', '==', 'active')
        );
        const snapshot = await getDocs(q);
        
        // Simple heuristic: flag consultations with unusual patterns
        const flaggedConsultations = snapshot.docs
          .map(doc => ({
            id: doc.id,
            ...doc.data(),
          }))
          .filter(cons => {
            // Example: flag very short consultations
            return cons.durationSeconds < 10;
          });

        setAlerts(flaggedConsultations);
      } catch (error) {
        console.error('Error fetching alerts:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchAlerts();
  }, []);

  const columns = [
    {
      title: 'Consultation ID',
      dataIndex: 'id',
      key: 'id',
      render: (text) => text.substring(0, 12) + '...',
    },
    {
      title: 'User',
      dataIndex: 'userId',
      key: 'userId',
      render: (text) => text.substring(0, 8) + '...',
    },
    {
      title: 'Lawyer',
      dataIndex: 'lawyerId',
      key: 'lawyerId',
      render: (text) => text.substring(0, 8) + '...',
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'Duration',
      dataIndex: 'durationSeconds',
      key: 'duration',
      render: (seconds) => `${Math.floor(seconds / 60)}m ${seconds % 60}s`,
    },
    {
      title: 'Alert',
      dataIndex: 'alert',
      key: 'alert',
      render: () => <Tag color="red"><WarningOutlined /> Suspicious Pattern</Tag>,
    },
    {
      title: 'Actions',
      key: 'actions',
      render: () => (
        <Space>
          <Button type="primary" size="small">Review</Button>
          <Button danger size="small">Block</Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <h1>Fraud Detection</h1>

      <Alert
        message="Monitoring suspicious patterns"
        description="Automated alerts for unusual consultation patterns, rapid transactions, and potential fraud indicators."
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
      />

      <Card>
        <Table
          columns={columns}
          dataSource={alerts}
          rowKey="id"
          loading={loading}
          pagination={{ pageSize: 20 }}
        />
      </Card>
    </div>
  );
};

export default FraudDetection;
